import {AfterViewInit, Component, inject, OnInit} from '@angular/core';
import { User } from '../../../core/models/user';
import { Select, Store } from '@ngxs/store';
import { UserState } from '../../state/user.state';
import { Observable } from 'rxjs';
import { Helper } from '../../helper/helper';
import { MenuItem } from 'primeng/api';
import { LogoutUser } from '../../state/user.actions';
import Role from '../../enums/role.enum';

@Component({
    selector: 'app-main-nav',
    templateUrl: './main-nav.component.html',
    styleUrls: ['./main-nav.component.scss'],
})
export class MainNavComponent implements OnInit, AfterViewInit {
    user: User;
    dropdownMenu: MenuItem[];
    langSwitch = 'de';
    $currentUser= inject(Store).select(state => state.currentUser);


    constructor(
        private store: Store,
        public helper: Helper,
    ) {
        this.$currentUser.subscribe((data) => (this.user = data));
        const uri = window.location.pathname.split('/');
        switch (uri[1]) {
            case 'de':
                this.langSwitch = 'en';
                break;
            case 'en':
                this.langSwitch = 'de';
                break;
            default:
                this.langSwitch = 'de';
        }
    }

    ngOnInit(): void {
        this.dropdownMenu = [];
    }

    logout(): void {
        this.store.dispatch(new LogoutUser());
    }

    ngAfterViewInit(): void {
        if (this.helper.hasRole(Role.BUYER)) {
            this.dropdownMenu.push({
                label: 'Navigation',
                items: [
                    {
                        label: $localize`:@@navigation.start:Start`,
                        icon: 'fa-regular fa-border-all',
                        routerLink: '/dashboard',
                    },
                    {
                        label: 'Suppliers',
                        //label:  $localize`:@@navigation.overview:Übersicht`,
                        icon: 'fa-regular fa-map-location-dot',
                        routerLink: '/directory/s/overview',
                    },
                    {
                        label: $localize`:@@fam-trips:FAM Trips`,
                        icon: 'fa-light fa-plane-departure fa-fw',
                        routerLink: '/fam-trips/b/overview',
                    },
                ],
            });
        }
        // Wenn Supplier
        if (this.helper.hasRole(Role.SUPPLIER)) {
            this.dropdownMenu.push({
                label: 'Navigation',
                items: [
                    {
                        label: $localize`:@@navigation.start:Start`,
                        icon: 'fa-regular fa-border-all',
                        routerLink: '/dashboard',
                    },
                    {
                        label: 'Buyers',
                        //label:  $localize`:@@navigation.overview:Übersicht`,
                        icon: 'fa-regular fa-map-location-dot',
                        routerLink: '/directory/b/overview',
                    },
                    {
                        label: $localize`:@@fam-trips:FAM Trips`,
                        icon: 'fa-light fa-plane-departure fa-fw',
                        routerLink: '/fam-trips/s/overview',
                    },
                ],
            });
        }

        if (this.helper.hasRole(Role.SUPPLIER)) {
            this.dropdownMenu.push({
                label: $localize`:@@navigation.account:Account`,
                icon: 'fal fa-fw fa-user',
                items: [
                    {
                        label: $localize`:@@navigation.my.account:Mein Account`,
                        icon: 'fa-regular fa-address-card',
                        routerLink: '/account',
                    },
                    {
                        label: 'Logout',
                        icon: 'fa-regular fa-arrow-right-from-bracket',
                        command: () => {
                            this.logout();
                        },
                    },
                ],
            });
            if (!this.helper.isReadOnly()) {
                this.dropdownMenu.push(
                    {
                        label: $localize`:@@myproducts:Meine Standorte`,
                        icon: 'fa-light fa-house-chimney-user fa-fw',
                        routerLink: '/account/products',
                    },
                    {
                        label: $localize`:@@mysubscription:Buchung`,
                        icon: 'fa-light fa-cloud fa-fw',
                        routerLink: '/subscription/booking',
                    },
                );
            }
        } else {
            let items = [];
            if (!this.helper.isReadOnly()) {
                items.push(
                    {
                        label: $localize`:@@myproducts:Meine Standorte`,
                        icon: 'fa-light fa-house-chimney-user fa-fw',
                        routerLink: '/account/buyer/products',
                    },
                    {
                        label: $localize`:@@mysubscription:Buchung`,
                        icon: 'fa-light fa-cloud fa-fw',
                        routerLink: '/subscription/booking',
                    },
                );
                items.push(
                    {
                        label: $localize`:@@navigation.my.account:Mein Account`,
                        icon: 'fa-regular fa-address-card',
                        routerLink: '/account',
                    },
                    {
                        label: 'Logout',
                        icon: 'fa-regular fa-arrow-right-from-bracket',
                        command: () => {
                            this.logout();
                        },
                    },
                );
            }
            this.dropdownMenu.push({
                label: $localize`:@@navigation.account:Account`,
                icon: 'fal fa-fw fa-user',
                items: items,
            });
        }

        if (this.helper.hasRole(Role.ADMINISTRATOR)) {
            this.dropdownMenu.push({
                label: 'Admin',
                items: [
                    {
                        label: 'Login as User',
                        icon: 'fa-regular fa-arrow-right-to-bracket fa-fw',
                        routerLink: '/account/switch-user',
                    },
                    {
                        label: $localize`:@@navigation.overview.admin.supplier:Übersicht Suppliers`,
                        icon: 'fa-regular fa-map-location-dot',
                        routerLink: '/directory/s/overview',
                    },
                    {
                        label: $localize`:@@navigation.overview.admin.buyer:Übersicht Buyers`,
                        icon: 'fa-regular fa-map-location-dot',
                        routerLink: '/directory/b/overview',
                    },
                    {
                        label: $localize`:@@navigation.overview.admin.famtrips:Übersicht FAM Trips`,
                        icon: 'fa-regular fa-map-location-dot',
                        routerLink: '/fam-trips/b/overview',
                    },
                ],
            });
        }

        this.dropdownMenu.push({
            label: $localize`:@@navigation.informations:Informationen`,
            items: [
                {
                    label: $localize`:@@navigation.imprint:Impressum`,
                    url: $localize`:@@navigation.imprint.url:https://www.lobster-event.com/de/impressum`,
                    target: '_blank',
                },
                {
                    label: $localize`:@@navigation.privacy.policy:Datenschutzerklärung`,
                    url: $localize`:@@navigation.privacy.policy.url:https://www.lobster-event.com/de/datenschutzerklaerung`,
                    target: '_blank',
                },
                {
                    label: $localize`:@@navigation.terms.of.use:Nutzungsbedingungen`,
                    url: $localize`:@@navigation.terms.of.use.url:https://www.lobster-event.com/de/allgemeine-nutzungsbedingungen`,
                    target: '_blank',
                },
            ],
        });
    }
}
